import axios from 'axios';

export function $axios({ baseURL, countryCode } = {}) {
  if (typeof window === 'object') {
    return axios.create();
  } else {
    if (!baseURL) {
      throw new Error('Missing baseURL while doing axios request server-side');
    }
    if (!countryCode) {
      throw new Error(
        'Missing countryCode while doing axios request server-side'
      );
    }
    return axios.create({
      baseURL: baseURL,
      headers: {
        common: {
          Cookie: `local=${countryCode}`,
        },
      },
    });
  }
}
